module.exports = __webpack_public_path__ + "static/furniture-featured-categories-section-67ba5b51c8c5ea9ed3f804d99c196770.png";